//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import UiIcon from './UiIcon.vue';

export default {
  name: 'UiCloseButton',

  components: {
    UiIcon,
  },

  props: {
    size: {
      type: String,
      default: 'normal', // 'mini', small', 'normal', or 'large'
    },
    color: {
      type: String,
      default: 'black', // 'black', or 'white'
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    classes() {
      return [
        `ui-close-button--size-${this.size}`,
        `ui-close-button--color-${this.color}`,
        { 'is-disabled': this.disabled || this.loading },
      ];
    },
  },

  methods: {
    onClick(e) {
      this.$emit('click', e);
    },
  },
};

